module.exports = __webpack_public_path__ + "img/8-424-424.adb7b087.png";